import React from 'react';
import { Link } from 'react-router-dom';
import HighlightList from './HighlightList';
import SectionHeader from './SectionHeader';
import pageAssets from '../../../data/pageAssets';
import AppImage from '../media/AppImage';

const ProductShowcaseSection = ({
    sectionClassName,
    sectionId,
    sectionHeader,
    gridClassName,
    imageClassName,
    contentClassName,
    subtitleClassName,
    bodyClassName,
    data,
    cta,
    highlightListClassName,
    highlightItemClassName,
    highlightIconClassName
}) => (
    <section id={sectionId} className={sectionClassName}>
        <div className="container">
            {sectionHeader ? (
                <SectionHeader
                    wrapperClassName={sectionHeader.wrapperClassName}
                    subtitleClassName={sectionHeader.subtitleClassName}
                    titleClassName={sectionHeader.titleClassName}
                    descriptionClassName={sectionHeader.descriptionClassName}
                    subtitle={sectionHeader.subtitle}
                    title={sectionHeader.title}
                    description={sectionHeader.description}
                />
            ) : null}
            <div className={gridClassName}>
                <div className={imageClassName}>
                    <AppImage src={pageAssets[data.imageKey]} alt={data.imageAlt} />
                </div>
                <div className={contentClassName}>
                    <div className={subtitleClassName}>{data.subtitle}</div>
                    <h2>
                        {data.titlePrefix} <span>{data.titleHighlight}</span> {data.titleSuffix}
                    </h2>
                    <p className={bodyClassName}>{data.description}</p>
                    <HighlightList
                        items={data.highlights}
                        listClassName={highlightListClassName}
                        itemClassName={highlightItemClassName}
                        iconWrapperClassName={highlightIconClassName}
                    />
                    {cta.type === 'link' ? (
                        <Link to={cta.to} className={cta.className}>{cta.label}</Link>
                    ) : (
                        <button type="button" className={cta.className} onClick={cta.onClick}>{cta.label}</button>
                    )}
                </div>
            </div>
        </div>
    </section>
);

export default ProductShowcaseSection;
